import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import ContentTabs from "@repoflow/components/content-tabs";
import { useSectionContext } from "@repoflow/components/section";
import * as widgets from "widgets/register";

import { useEditorPage } from "../../../context";
import { ThisLanguageOnly } from "../../../translation";
import * as ConfigRoute from "../../config";

// A `paragraph` element: prose, written in a rich-text editor.
//
// One field and therefore one tab beside Element, the same shape a `section`
// element's screen has. The tab exists so that the editor is the first thing on
// the screen rather than something you reach by scrolling past the frame and
// the tags — a paragraph is the one element type whose content is the reason
// somebody opened it.
//
// The label on the field is blank. `Content` is what the tab already says, and
// form-schema puts a label above a wide field rather than beside it, so keeping
// it would print the word twice with nothing between the two.
const FIELDS = {
  "/Page/Element/Type/Paragraph": {
    fields: [{ property: "content", label: "", layout: "wide" }],
  },
};

const Write = () => {
  const { schema, state } = useSectionContext();
  const { values, setValues } = state;
  // A paragraph is prose and nothing else, so all of it is this language's —
  // the one element type with no shared half at all.
  const { languages } = useEditorPage();

  return (
    <Row>
      <Col>
        <ThisLanguageOnly languages={languages} />
        <Form
          schema={schema}
          target={{ $ref: "/Page/Element/Type/Paragraph" }}
          widgets={widgets}
          // `config` and not the element: `content` belongs to the branch of
          // the oneOf that `type` selected, and writing it onto the element
          // itself would put it somewhere the schema does not declare and the
          // API would reject.
          values={values.config || {}}
          onChange={(mod) => setValues({ ...values, config: mod })}
          config={FIELDS}
        />
      </Col>
    </Row>
  );
};

export const Content = () => {
  const tabs = useMemo(
    () => [
      { label: "Content", content: <Write /> },
      { label: "Element", content: <ConfigRoute.Content /> },
    ],
    []
  );

  return <ContentTabs tabs={tabs} />;
};
